module.exports = __webpack_public_path__ + "img/icon-delete-normal.5fd09a5d.svg";